import { render, staticRenderFns } from "./TvShows.vue?vue&type=template&id=72675cb8"
import script from "./TvShows.vue?vue&type=script&lang=js"
export * from "./TvShows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports